import Vue from 'vue';

export default context =>
  // context.code,
   Vue.$http.post('/airbnb/user-create', {
     airbnbxml_channel_id: context.code,
     oauth_token: context.token,
   })
    .then((response) => {
      context.currentAirbnbXmId = response.data.channel.id;
      context.currentAibnbAccountId = response.data.airbnb_account.id;
    })
    .catch((error) => {
      console.log(error.response.data, '[GET] /airbnb/user-create');
      toastr.error(error.response.data.msg);
    })
    .finally(() => {
    });



// WEBPACK FOOTER //
// ./src/app/services/airbnb/user-create.js